import styled from 'styled-components';

const SearchWrapper = styled.div`
    display: flex;
    padding: 24px;
`;

export default SearchWrapper;
